<template>
  <div>
    <Overview v-if="!showChat" @setChatSession="setChatSession"></Overview>
    <Chat v-if="showChat" :chatSession="chatSession" @back="showChat = false"></Chat>
  </div>
</template>

<script>
import Overview from '@/componentsv3/LoopAi/Overview.vue';
import Chat from '@/componentsv3/LoopAi/Chat.vue';

export default {
  name: "LoopAi",

  components: { Overview, Chat },

  data() {
    return {
      showChat: false,
      chatSession: {
        sessionId: null,
        prompt: null
      }
    };
  },

  mounted() {},

  methods: {
    setChatSession(chatSession) {
      this.chatSession = chatSession;
      this.showChat = true;
    }
  }
}
</script>
